import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiUpdateIapPollRequestBody,
  IApiUpdateIapPollResponseBody,
} from '../IapPollsApi.types';
import { useApi } from '~/lib/api/useApi';
import { iapPollQueryKeyFactory } from './useIapPollQuery';
import { iapPollsQueryKeyFactory } from './useIapPollsQuery';

export type IUseUpdateIapPollMutationValues = {
  appId: string;
  iapPollId: string;
  body: IApiUpdateIapPollRequestBody;
};

export const useUpdateIapPollMutation = (): UseMutationResult<
  IApiUpdateIapPollResponseBody,
  unknown,
  IUseUpdateIapPollMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values) =>
      api.iapPolls.update(values.appId, values.iapPollId, values.body),
    onSuccess: async (updatedIapPoll, values) => {
      queryClient.setQueryData(
        iapPollQueryKeyFactory({
          ...values,
          iapPollId: updatedIapPoll._id,
        })!,
        updatedIapPoll,
      );
      await queryClient.invalidateQueries({
        queryKey: iapPollsQueryKeyFactory(),
      });
    },
  });
};
